// modules/components/inkind/EditContributionModal.js
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    CircularProgress,
} from '@mui/material';
import { useNotify } from 'react-admin';

const token = JSON.parse(localStorage.getItem('token'));

const EditContributionModal = ({ open, onClose, record, isService = false }) => {
    const notify = useNotify();
    const [value, setValue] = useState('');
    const [saving, setSaving] = useState(false);

    // Reset the selected value whenever a new record is opened
    React.useEffect(() => {
        if (open && record) {
            setValue(record.contribution_percentage != null ? String(record.contribution_percentage) : '');
        }
    }, [open, record]);

    const handleConfirm = async () => {
        try {
            setSaving(true);
            const endpoint = isService ? 'services' : 'offers';
            const response = await fetch(`${process.env.REACT_APP_URL}/admin/${endpoint}/${record.id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ contribution_percentage: value || null }),
            });

            if (!response.ok) throw new Error('Failed to update contribution percentage');

            notify('Contribution percentage updated', { type: 'success' });
            onClose(true);
        } catch (error) {
            notify(error.message || 'Failed to update contribution percentage', { type: 'error' });
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={() => !saving && onClose(false)} maxWidth="xs" fullWidth>
            <DialogTitle>Edit Contribution Percentage</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Update the contribution percentage for this {isService ? 'service' : 'offer'}.
                </Typography>
                <FormControl fullWidth>
                    <InputLabel id="contribution-percentage-label">Contribution %</InputLabel>
                    <Select
                        labelId="contribution-percentage-label"
                        label="Contribution %"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        disabled={saving}
                    >
                        <MenuItem value=""><em>Not specified</em></MenuItem>
                        <MenuItem value="10">10%</MenuItem>
                        <MenuItem value="20">20%</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} disabled={saving}>
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="primary"
                    disabled={saving}
                    startIcon={saving ? <CircularProgress size={18} color="inherit" /> : null}
                >
                    {saving ? 'Saving...' : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditContributionModal;
